export default function getUibDropdownCtrl($parse) {
  'ngInject';

  return {
    require: 'uibDropdown',
    link($scope, $element, $attrs, $ctrl) {
      const parsed = $parse($attrs.getUibDropdownCtrl);
      if (!parsed.assign) {
        throw `[getUibDropdownCtrl] Expression "${$attrs.getUibDropdownCtrl}" not assignable!`;
      }

      parsed.assign($scope, $ctrl);
    },
  };
}
